const ONE_MINUTE_MS = 60 * 1000;
const ONE_DAY_MS = 24 * 60 * 60 * 1000;

export type QueuedDisplay =
  | { mode: 'relative' }
  | { mode: 'hhmm'; text: string };

/**
 * Formats TimeInQueue for the Queued column.
 * - 1 day or more: relative ("N days ago") via ReactTimeAgo
 * - under 1 day and over 1 minute: elapsed hh:mm
 * - under 1 minute: relative seconds via ReactTimeAgo
 */
export function formatQueuedDisplay(
  timeInQueue: string | Date | null | undefined,
  now: number = Date.now()
): QueuedDisplay | null {
  if (!timeInQueue) return null;

  const date = timeInQueue instanceof Date ? timeInQueue : new Date(timeInQueue);
  if (Number.isNaN(date.getTime())) return null;

  const elapsedMs = Math.max(0, now - date.getTime());

  if (elapsedMs >= ONE_DAY_MS || elapsedMs < ONE_MINUTE_MS) {
    return { mode: 'relative' };
  }

  const totalMinutes = Math.floor(elapsedMs / ONE_MINUTE_MS);
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  return {
    mode: 'hhmm',
    text: `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`,
  };
}
